import React from "react";
import { useDispatch } from "react-redux";
import { FaTrashAlt } from "react-icons/fa";
import { deleteCartAction } from "store/actions/cartAction";
import pizzalabel from "assets/img/pizzalabel.svg";
import ItemCounter from "../Cart/ItemCounter";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

const OrderedItems = ({ cartItems, cartData }) => {
  const dispatch = useDispatch();

  const capitalizeWords = (str) =>
    str?.replace(/\b\w/g, (char) => char.toUpperCase()) || "";

  return (
    <>
      {/* <span className="text-dark fw--500">Order Details</span> */}
      {cartItems?.map((item, index) => {
        const isOffer = item?.type === "offer";
        const isItem = !isOffer;
        return (
          <div
            key={index}
            className="position-relative py-3 d-flex align-items-start border-bottom border-lighter custom-flex"
            style={{ paddingRight: "155px" }}
          >
            <div className="flex-shrink-0 text-center mb-4 mb-md-0">
              {Array.isArray(item?.images) && item.images.length <= 1 ? (
                <img
                  alt={item?.name}
                  src={item?.images?.[0] || pizzalabel}
                  width={150}
                  height={150}
                  style={{
                    minWidth: "150px",
                    maxWidth: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Swiper
                  modules={[Autoplay]}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  spaceBetween={10}
                  slidesPerView={1}
                  style={{
                    width: "150px",
                    height: "160px",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  {(isOffer ? [item?.images] : item?.images)?.map(
                    (img, idx) => (
                      <SwiperSlide key={idx}>
                        <img
                          alt={`slide-${idx}`}
                          src={img || pizzalabel}
                          style={{
                            minWidth: "150px",
                            maxWidth: "150px",
                            height: "150px",
                            borderRadius: "10px",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              )}
            </div>

            <div className="d-flex flex-row ml-3 w-100">
              <div className="w-100">
                <h4 className="text-dark fs--18 fw--600 ">{item?.name}</h4>

                {isItem && (
                  <h6 className="text-muted fw--400">Size : {item?.size}</h6>
                )}
                <div className="text-muted fw--400">
                  <span className="text-dark">
                    Price: {item?.currency || "$"}
                    {item?.price}
                  </span>
                </div>

                {isOffer && item?.cartItems?.length > 0 && (
                  <div
                    className="row gx-3 gy-3 mt-2 w-100"
                    style={{ marginLeft: 0, marginRight: 0 }}
                  >
                    {item.cartItems.map((entry) => {
                      return (
                        <div
                          key={entry.id}
                          className="col-12 col-lg-6 col-xl-4 mb-3 pl-0"
                        >
                          <div
                            className="p-2 h-100 d-flex flex-column justify-content-between shadow-dark"
                            style={{
                              borderRadius: "8px",
                              boxShadow: "0 0 6px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            <div className="d-flex align-items-center mb-2">
                              <img
                                src={entry.image}
                                alt={entry.name}
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "cover",
                                  borderRadius: "6px",
                                }}
                              />

                              <div className="ms-2 ml-2 flex-grow-1 overflow-hidden">
                                <h6
                                  className="mb-0 text-truncate"
                                  style={{
                                    maxWidth: "100%",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                  title={entry?.itemName}
                                >
                                  {capitalizeWords(entry?.itemName)}
                                </h6>
                                {isOffer && entry.variant && (
                                  <p
                                    className="mb-0 text-dark"
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      color: "rgb(5, 5, 12)",
                                    }}
                                  >
                                    Variant: {entry.variant}
                                  </p>
                                )}
                                <p
                                  className="mb-0 text-muted"
                                  style={{ fontSize: "14px" }}
                                >
                                  Quantity: {entry.quantity}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <div
              className="position-absolute right-0 py-2 d-flex flex-column justify-content-between text-muted fw--400"
              style={{
                bottom: "0",
                top: "0",
                height: "100%",
              }}
            >
              <div className="d-flex justify-content-end pt-2 w-100">
                <FaTrashAlt
                  size={24}
                  onClick={() => {
                    dispatch(deleteCartAction(item));
                  }}
                  className="text-danger cursor-pointer"
                />
              </div>

              <div className="">
                <div className="d-flex justify-content-center align-items-center px-0">
                  <ItemCounter cartItem={item} cartData={cartData} />
                </div>
                <span className="text-dark fw--500">
                  Item Total:&nbsp;
                </span>
                <span className="text-success custom-price-color fw--16 ">{item?.currency || "$"}&nbsp;{item?.totalPrice}</span>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default OrderedItems;
